//react
import { useEffect, useState, useRef, useReducer } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
import { M, MMinus, MPlus, T } from "../../../../utils/MT";

// img
import DelSvg from "../../../../assets/img/icon/del.svg";
import AnswerSvg from "../../../../assets/img/icon/icon_answer.svg";

// componet
import BasicBtn from "../../../../component/button/BasicBtn";
import Pagination from "../../../../component/pagination/Pagination";

// testData
import { qnaListData } from "../../../../Data";

export default function MyInquiryList({ setDelModal }) {
    //페이지 이동
    const navigate = useNavigate();
    const goInquiry = () => {
        navigate("new");
    };

    // 텍스트 자르기!!!
    function SliceText(text, int) {
        if (text.length < int) {
            return text;
        }
        let newText = text;
        newText = newText.substring(0, int) + "…";
        return newText;
    }

    // 문의글 토글
    const [shownComments, setShownComments] = useState({});
    const toggleComment = (id) => {
        setShownComments((prevShownComments) => ({
            ...prevShownComments,
            [id]: !prevShownComments[id],
        }));
    };

    return (
        <Warp>
            <InnerWrap>
                <Seciton>
                    <Title>1:1문의</Title>
                    <SubTitleWrap>
                        <SubTitle>1:1문의내역</SubTitle>
                        <SubDescWrap>
                            <SubDesc>
                                상담시간 평일&#40;월 ~ 금&#41; 10:00 ~ 17:00 &nbsp;
                                <MbBr />
                                &#40;Off-time 12:00 ~ 14:00, 토/일/공휴일 휴무&#41;
                            </SubDesc>
                            <BtnWrap>
                                <BasicBtn onClick={goInquiry} text="1:1문의 쓰기" />
                            </BtnWrap>
                        </SubDescWrap>
                    </SubTitleWrap>
                    <PC>
                        <TheadWrap>
                            <Thead>상담구분</Thead>
                            <Thead>상담제목</Thead>
                            <Thead>작성일</Thead>
                            <Thead>답변유무</Thead>
                        </TheadWrap>
                    </PC>
                    <ListWrap>
                        {/* 상품 문의 내역이 없을때 */}
                        {/* <NotInquiry>1:1 문의 내역이 없습니다.</NotInquiry>  */}
                        {qnaListData.map((list, index) => {
                            return (
                                <QnaListBox key={"qnaDataList" + index}>
                                    <SimpleQnaBox>
                                        <QnaCate>[{list.cate}]</QnaCate>
                                        <QnaTitle onClick={() => toggleComment(list.id)}>{SliceText(list.content, 4)}</QnaTitle>
                                        <QanDate>{list.date}</QanDate>
                                        <QnaInfoBtnWrap>
                                            {
                                                // 답변이 있을때
                                                list.answer ? <BasicBtn text="답변완료" border="true" /> : <BasicBtn text="답변대기" gray="true" />
                                            }
                                        </QnaInfoBtnWrap>
                                        <QnaDelWrap>
                                            <DelIcon onClick={() => setDelModal(true)} src={DelSvg} alt="삭제" />
                                        </QnaDelWrap>
                                    </SimpleQnaBox>
                                    {shownComments[list.id] ? (
                                        <HideQnaBox>
                                            <QnaContent>
                                                <p>{list.content}</p>
                                                <ImgListWrap>
                                                    {list.imglist?.map((item, index) => {
                                                        return (
                                                            <ImgList key={"ImgList" + item.id}>
                                                                <Img src={item.content} alt="사진" />
                                                            </ImgList>
                                                        );
                                                    })}
                                                </ImgListWrap>
                                            </QnaContent>
                                            {/* 문의글 답변 */}
                                            {list.answer ? (
                                                <AnswerArea>
                                                    <AnswerIcon src={AnswerSvg} alt="답변 아이콘" />
                                                    <AnswerContent>
                                                        <AnswerText>{list.answer}</AnswerText>
                                                        <AnswerDate>{list.answerdate}</AnswerDate>
                                                    </AnswerContent>
                                                </AnswerArea>
                                            ) : null}
                                        </HideQnaBox>
                                    ) : null}
                                </QnaListBox>
                            );
                        })}
                    </ListWrap>
                    {
                        <PageNationWrap>
                            <Pagination />
                        </PageNationWrap>
                    }
                </Seciton>
            </InnerWrap>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    margin: 0 auto;
`;
const InnerWrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const Seciton = styled.section`
    margin-bottom: calc(100vw * (45 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (45 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(100)};
    }
`;
const PageNationWrap = styled.div``;

/* 3. 상품문의 */
const ListWrap = styled.ul`
    margin: calc(100vw * (20 / 1920)) 0 calc(100vw * (180 / 1920));

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (20 / 1300)) 0 calc(100vw * (180 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(10)} 0 ${M(100)};
    }
`;
const Title = styled.h2`
    font-size: calc(100vw * (25 / 1920));

    padding-bottom: calc(100vw * (19 / 1920));
    margin-bottom: calc(100vw * (20 / 1920));
    border-bottom: 1px solid #000;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));

        padding-bottom: calc(100vw * (19 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        padding-bottom: ${M(20)};
        margin-bottom: ${M(20)};
    }
`;
const QnaListBox = styled.li`
    position: relative;
    border-bottom: 1px solid #eeeeee;
`;

const SimpleQnaBox = styled.ul`
    display: flex;
    align-items: center;

    justify-content: space-between;

    padding: calc(100vw * (15 / 1920)) 0;

    & > li {
        text-align: center;
        flex-shrink: 0;
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (15 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        display: block;
        padding: ${M(15)} 0;

        & > li {
            text-align: left;
        }
    }
`;

const QnaCate = styled.li`
    width: calc(100vw * (105 / 1920));

    font-size: calc(100vw * (15 / 1920));
    color: #aaa;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (105 / 1300));

        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        font-size: ${M(14)};
        margin-bottom: ${M(10)};
    }
`;
const QanDate = styled.li`
    width: calc(100vw * (118 / 1920));
    font-size: calc(100vw * (15 / 1920));
    color: #8c8c8c;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (118 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        font-size: ${M(14)};
    }
`;

const QnaTitle = styled.li`
    font-size: calc(100vw * (15 / 1920));

    width: calc(100vw * (455 / 1920));
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-wrap: break-word;

    margin-right: auto;

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        width: calc(100vw * (455 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        font-size: ${M(14)};
        margin-bottom: ${M(10)};
    }
`;

const QnaDelWrap = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;

    width: calc(100vw * (39 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (39 / 1300));
    }

    @media screen and (max-width: 900px) {
        position: absolute;
        top: ${M(10)};
        right: 0;

        width: ${M(16)};
    }
`;
const DelIcon = styled.img`
    width: calc(100vw * (18 / 1920));
    height: calc(100vw * (21 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (18 / 1300));
        height: calc(100vw * (21 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        height: ${M(17)};
    }
`;

const QnaInfoBtnWrap = styled.li`
    width: calc(100vw * (123 / 1920));
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    & > p {
        width: calc(100vw * (97 / 1920));
        padding: calc(100vw * (9 / 1920)) 0;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (123 / 1300));

        & > p {
            width: calc(100vw * (97 / 1300));
            padding: calc(100vw * (9 / 1300)) 0;
        }
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        display: flex;

        & > p {
            width: ${M(97)};
            padding: ${M(9)} 0;

            margin-left: auto;
        }
    }
`;

const HideQnaBox = styled.div`
    width: 100%;

    padding: calc(100vw * (30 / 1920));
    margin: 0 auto calc(100vw * (30 / 1920));

    background: #fafafa;
    border-radius: 4px;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (30 / 1300));
        margin: 0 auto calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} ${M(16)};
        margin: 0 auto ${M(15)};
    }
`;
const QnaContent = styled.div`
    /* width: calc(100vw * (623 / 1920)); */
    width: 100%;

    margin-left: calc(100vw * (105 / 1920));
    padding-bottom: calc(100vw * (20 / 1920));

    & > p {
        font: calc(100vw * (15 / 1920)) "Noto-R";

        margin-bottom: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (105 / 1300));
        padding-bottom: calc(100vw * (20 / 1300));

        & > p {
            font-size: calc(100vw * (15 / 1300));

            margin-bottom: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin-left: 0;
        padding-bottom: ${M(20)};

        & > p {
            font-size: ${M(14)};

            margin-bottom: ${M(20)};
        }
    }
`;
const ImgListWrap = styled.ul``;
const ImgList = styled.li`
    width: calc(100vw * (512 / 1920));
    height: calc(100vw * (512 / 1920));
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #ddd;

    &:not(:first-child) {
        margin-top: calc(100vw * (15 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (512 / 1300));
        height: calc(100vw * (512 / 1300));

        &:not(:first-child) {
            margin-top: calc(100vw * (15 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(120)};
        height: ${M(120)};

        &:not(:first-child) {
            margin-top: ${M(10)};
        }
    }
`;
const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
const AnswerArea = styled.div`
    display: flex;

    padding-top: calc(100vw * (20 / 1920));
    margin-left: calc(100vw * (105 / 1920));

    border-top: 1px solid #ddd;

    @media screen and (max-width: 1300px) {
        padding-top: calc(100vw * (20 / 1300));
        margin-left: calc(100vw * (105 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-top: ${M(20)};
        padding-left: ${M(14)};
        margin-left: 0;
    }
`;
const AnswerIcon = styled.img`
    flex-shrink: 0;
    width: calc(100vw * (18 / 1920));
    height: calc(100vw * (23 / 1920));

    margin-right: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (18 / 1300));
        height: calc(100vw * (23 / 1300));

        margin-right: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(18)};
        height: ${M(23)};

        margin-right: ${M(14)};
    }
`;
const AnswerContent = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (623 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (623 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(280)};
    }
`;

const AnswerText = styled.p`
    width: 100%;

    font: calc(100vw * (15 / 1920)) "Noto-R";

    margin-bottom: calc(100vw * (9 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (9 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(10)};
    }
`;
const AnswerDate = styled.p`
    font: calc(100vw * (15 / 1920)) "Noto-R";
    color: #aaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
const NotInquiry = styled.p`
    text-align: center;
    margin: calc(100vw * (145 / 1920)) 0;

    font-size: calc(100vw * (15 / 1920));
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (145 / 1300)) 0;

        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(145)} 0;

        font-size: ${M(15)};
    }
`;

const SubTitleWrap = styled.div`
    margin-bottom: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(10)};

        border-bottom: 1px solid #eee;
    }
`;
const SubTitle = styled.div`
    font-size: calc(100vw * (20 / 1920));

    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));

        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(16)};

        margin-bottom: ${M(14)};
    }
`;

const SubDescWrap = styled.div`
    display: flex;
    align-items: center;

    justify-content: space-between;
    margin-bottom: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        display: block;
        margin-bottom: ${M(20)};
    }
`;
const SubDesc = styled.p`
    position: relative;
    font: calc(100vw * (16 / 1920)) "Noto-R";
    color: #aaaaaa;

    padding-left: calc(100vw * (15 / 1920));

    &:after {
        position: absolute;
        top: 50%;
        left: 0;
        content: "";
        width: calc(100vw * (10 / 1920));
        height: 1px;
        background: #aaaaaa;
        transform: translateY(-50%);
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (16 / 1300));

        padding-left: calc(100vw * (15 / 1300));

        &:after {
            width: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        padding-left: ${M(15)};

        margin-bottom: ${M(20)};

        &:after {
            top: ${M(10)};
            width: ${M(10)};
        }
    }
`;
const BtnWrap = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (150 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (150 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(150)};
    }
`;

const TheadWrap = styled.ul`
    display: flex;
    align-items: center;

    padding: calc(100vw * (20 / 1920)) 0;
    background: #fafafa;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        /* width: ${M(78)}; */
    }
`;
const Thead = styled.li`
    flex-shrink: 0;
    font-size: calc(100vw * (15 / 1920));
    text-align: center;

    &:nth-child(1) {
        width: calc(100vw * (105 / 1920));
    }
    &:nth-child(2) {
        width: calc(100vw * (455 / 1920));
    }
    &:nth-child(3) {
        width: calc(100vw * (118 / 1920));
    }
    &:nth-child(4) {
        width: calc(100vw * (123 / 1920));
    }
    &:nth-child(5) {
        width: calc(100vw * (39 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        &:nth-child(1) {
            width: calc(100vw * (105 / 1300));
        }
        &:nth-child(2) {
            width: calc(100vw * (455 / 1300));
        }
        &:nth-child(3) {
            width: calc(100vw * (118 / 1300));
        }
        &:nth-child(4) {
            width: calc(100vw * (123 / 1300));
        }
        &:nth-child(5) {
            width: calc(100vw * (39 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        /* width: ${M(78)}; */
    }
`;

const MbBr = styled.br`
    display: none;

    @media screen and (max-width: 900px) {
        display: block;
    }
`;
